/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Specification - Omobility app
 * OpenAPI documentation for Omobility app with Keycloak user authentication
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SortCriteria
 */
export interface SortCriteria {
    /**
     * 
     * @type {string}
     * @memberof SortCriteria
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof SortCriteria
     */
    'direction'?: SortCriteriaDirectionEnum;
}

export const SortCriteriaDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortCriteriaDirectionEnum = typeof SortCriteriaDirectionEnum[keyof typeof SortCriteriaDirectionEnum];


